(() => {
  const keys = ['warmwonders:pillow-wishlist:v1', 'warmwonders:blanket-wishlist:v1', 'warmwonders:style-wishlist:v1'];
  const read = key => { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.map(String) : []; };
  const refresh = root => {
    try {
      const saved = new Set(keys.flatMap(read));
      root.querySelectorAll('[data-cozy-heart]').forEach(button => {
        const active = saved.has(button.closest('[data-cozy-product]').dataset.cozyProduct);
        button.hidden = false;
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? button.dataset.unsaveLabel : button.dataset.saveLabel);
      });
    } catch (_) { root.querySelectorAll('[data-cozy-heart]').forEach(button => { button.hidden = true; }); }
  };
  const setup = root => {
    refresh(root);
    root.querySelectorAll('[data-cozy-carousel]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const row = section.querySelector('.cozy-products');
      const cards = [...row.querySelectorAll('.cozy-product')];
      const scrollbar = section.querySelector('.cozy-carousel-scrollbar');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const rtl = getComputedStyle(row).direction === 'rtl';
      let frame;
      const metrics = () => {
        const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        const step = (cards[0]?.getBoundingClientRect().width || 0) + gap;
        const count = Math.max(1, Math.round((row.clientWidth + gap - 12) / step));
        const first = Math.min(Math.round(Math.abs(row.scrollLeft) / step), Math.max(0, cards.length - count));
        return {step, count, first};
      };
      const update = () => {
        const max = row.scrollWidth - row.clientWidth;
        scrollbar.hidden = max < 2;
        scrollbar.value = max > 0 ? Math.min(100, Math.abs(row.scrollLeft) / max * 100) : 0;
        scrollbar.style.setProperty('--cozy-scroll-thumb', Math.max(40, scrollbar.clientWidth * row.clientWidth / row.scrollWidth) + 'px');
      };
      scrollbar.addEventListener('input', () => {
        row.classList.add('cozy-products-dragging');
        row.scrollTo({left: (row.scrollWidth - row.clientWidth) * Number(scrollbar.value) / 100 * (rtl ? -1 : 1), behavior: 'instant'});
      });
      const finishDrag = () => row.classList.remove('cozy-products-dragging');
      scrollbar.addEventListener('change', finishDrag);
      scrollbar.addEventListener('pointercancel', finishDrag);
      const go = index => {
        const {step} = metrics();
        row.scrollTo({left: index * step * (rtl ? -1 : 1), behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      };
      row.addEventListener('keydown', event => {
        if (event.target !== row) return;
        const {first, count} = metrics();
        if (event.key === 'ArrowRight') go(first + (rtl ? -count : count));
        else if (event.key === 'ArrowLeft') go(first + (rtl ? count : -count));
        else if (event.key === 'Home') go(0);
        else if (event.key === 'End') go(cards.length);
        else return;
        event.preventDefault();
      });
      row.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(row);
      const unload = event => {
        if (!event.target.contains(section)) return;
        observer.disconnect();
        cancelAnimationFrame(frame);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });
    root.querySelectorAll('.cozy-style-scrollbar').forEach(scrollbar => {
      if (scrollbar.dataset.ready) return;
      scrollbar.dataset.ready = 'true';
      const row = scrollbar.previousElementSibling;
      if (!row?.classList.contains('ww-categories')) return;
      const rtl = getComputedStyle(row).direction === 'rtl';
      let frame;
      const update = () => {
        const max = row.scrollWidth - row.clientWidth;
        scrollbar.hidden = max < 2;
        scrollbar.value = max > 0 ? Math.min(100, Math.abs(row.scrollLeft) / max * 100) : 0;
      };
      scrollbar.addEventListener('input', () => {
        row.classList.add('cozy-styles-dragging');
        row.scrollTo({left: (row.scrollWidth - row.clientWidth) * Number(scrollbar.value) / 100 * (rtl ? -1 : 1), behavior: 'instant'});
      });
      const finishDrag = () => row.classList.remove('cozy-styles-dragging');
      scrollbar.addEventListener('change', finishDrag);
      scrollbar.addEventListener('pointercancel', finishDrag);
      row.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(row);
      const unload = event => {
        if (!event.target.contains(scrollbar)) return;
        observer.disconnect();
        cancelAnimationFrame(frame);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });
  };
  document.addEventListener('click', event => {
    const heart = event.target.closest('[data-cozy-heart]');
    if (heart) {
      const card = heart.closest('[data-cozy-product]');
      const id = card.dataset.cozyProduct;
      try {
        const removing = keys.some(key => read(key).includes(id));
        const target = card.dataset.kind === 'blanket' ? keys[1] : keys[0];
        keys.forEach(key => {
          const values = new Set(read(key));
          if (removing) values.delete(id); else if (key === target) values.add(id);
          localStorage.setItem(key, JSON.stringify([...values]));
        });
        refresh(document);
      } catch (_) { const status = card.closest('.cozy-featured').querySelector('.cozy-save-status'); status.textContent = status.dataset.error; }
    }
    document.querySelectorAll('.cozy-header details[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.cozy-header details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  window.addEventListener('storage', () => refresh(document));
  setup(document);
})();
